import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Detail from './pages/Detail';
import Home from './pages/Home';
import Happy from './pages/Happy';
import AddData from './pages/AddData';
import Header from './pages/Header';


function App() {
  return (
    <>
   <Header/>
   <Routes>
    <Route path='/' element={<Home />} />
    <Route path='/detail' element={<Detail />} />
    <Route path='/happy' element={<Happy />} />
    <Route path='/addData' element={<AddData />} />
   </Routes>
   </>
  );
}


export default App;
